<template>
  <v-app>
    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="snackbar.timeout"
      :top="true"
      :right="true"
    >
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.message }}</div>
        </v-layout>
        <v-btn
          elevation="0"
          color="transparent"
          fab
          x-small
          dark
          @click="snackbar.visible = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <!-- <v-icon class="pr-3" dark medium @click="onCloseToast">mdi-close</v-icon> -->
      </v-layout>
    </v-snackbar>
    <Navigation v-if="isAuth" />
    <v-main>
      <v-card v-if="isAuth" class="rounded-0 d-flex" elevation="2" color="white">
        <v-icon small class="pl-3" color="indigo darken-4">mdi-home</v-icon>
                <v-breadcrumbs class="indigo--text text--darken-4 p-2 pl-1" :items="items">
                <template v-slot:divider>
                    <v-icon>mdi-chevron-right</v-icon>
                    </template>
                </v-breadcrumbs>
            </v-card>
      <v-container :class="isAuth ? '' : 'fluid fill-height'">
        <router-view @auth="updateAuthStatus" @toast="showToast" />
      </v-container>
    </v-main>

    <v-footer app></v-footer>
  </v-app>
</template>
<script>
import Navigation from "./components/layouts/Navigation.vue";
export default {
  components: { Navigation },
  data: () => ({
    isAuth: false,
    items: [
        {
          icon: 'mdi-home',
          text: 'Home',
          disabled: false,
          href: ''
        },
        {
          text: 'Internship',
          disabled: true,
          href: 'home-student',
        },
      ],
    snackbar: {
      color: null,
      icon: null,
      mode: null,
      message: null,
      timeout: 5000,
      title: null,
      visible: false,
     
    },
  }),
  created() {
    vm.appComponent = this;
    
    this.isAuth = localStorage.getItem("isAuth") === "true" ? true : false;
    this.items[0].href = this.$baseurl;
  },
  methods: {
    updateAuthStatus(isAuth) {
      this.isAuth = isAuth;
    },
    showToast(type, message = "") {
      if (!type) return;
      switch (type) {
        case "error":
          this.snackbar = {
            color: "error",
            icon: "mdi-close-circle",
            mode: "multi-line",
            position: "top",
            timeout: 3000,
            title: "Error",
            message: message,
            visible: true,
          };
          break;
        case "info":
          this.snackbar = {
            color: "info",
            icon: "mdi-information",
            mode: "multi-line",
            position: "top",
            timeout: 3000,
            title: "Information",
            message: message,
            visible: true,
          };
          break;
        case "success":
          this.snackbar = {
            color: "success",
            icon: "mdi-check-circle",
            mode: "multi-line",
            position: "top",
            timeout: 3000,
            title: "Success",
            message: message,
            visible: true,
          };
          break;
        case "warning":
          this.snackbar = {
            color: "warning",
            icon: "mdi-alert-circle",
            mode: "multi-line",
            position: "top",
            timeout: 3000,
            title: "Warning",
            message: message,
            visible: true,
          };
          break;
      }
    },
  },
};
</script>